import { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ConnectProto } from "@racoon/api";
import { setServiceProviderStats, clearServiceProviderStats } from "../stats.slice";
import { RootState } from "../../store";

export function useServiceProviderStats() {
  const dispatch = useDispatch();
  const stats = useSelector((s: RootState) => s.stats.serviceProviderStats);

  const setStats = useCallback(
    (stats: ConnectProto.ServiceProviderStats) => dispatch(setServiceProviderStats(stats)),
    [dispatch],
  );

  const clear = useCallback(() => dispatch(clearServiceProviderStats()), [dispatch]);

  return useMemo(
    () => ({
      stats,
      unassignedJobCount: stats?.unassignedJobCount,
      activeRouteCount: stats?.activeRouteCount,
      idleTruckCount: stats?.idleTruckCount,
      setStats,
      clear,
    }),
    [stats, setStats, clear],
  );
}
